const AUTH_ROUTE_PREFIXES = [
  "/auth",
  "/login",
  "/pin",
  "/register",
  "/signup",
  "/forgot-password",
  "/reset-password",
];

/**
 * Validates an ordinary post-authentication destination.
 * Only allows internal, same-origin paths and never auth workflow routes.
 */
export function validateOrdinaryPostAuthNext(raw: string | null | undefined): string {
  if (!raw || typeof raw !== "string") return "/";
  if (!raw.startsWith("/")) return "/";
  if (raw.startsWith("//")) return "/";

  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return "/";

    const path = url.pathname;
    const blocked = AUTH_ROUTE_PREFIXES.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`),
    );
    if (blocked) return "/";

    return `${path}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}

/** Builds an absolute URL respecting the app base path. */
export function buildAbsoluteUrl(path: string): string {
  const base = (typeof __BASE_PATH__ === "string" ? __BASE_PATH__ : "").replace(/\/$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${window.location.origin}${base}${cleanPath}`;
}

/** Landing route for each role after signing in. */
export function homeForRole(roleName: string | null | undefined): string {
  if (roleName === "admin") return "/admin";
  if (roleName === "cashier") return "/pos";
  return "/login";
}